import { useColorMode } from "@chakra-ui/react";

export const useLightMode = (pref?: string) => {
  const { colorMode } = useColorMode();
  let lightMode;
  if (pref) {
    lightMode = pref === "light";
  } else {
    lightMode = colorMode === "light";
  }
  return { lightMode };
};
